export default __webpack_public_path__ + "static/media/profile.083b1fe4.png";